import * as yup from "yup";

const compensationSchema = yup.object({
    appointmentNumber: yup
        .string()
        .trim()
        .required("AppointmentNumber is required."),
    effectiveDate: yup.string().trim().required("EffectiveDate is required.")

    /*    EffectiveDate: yup
        .string()
        .nullable()
        .test(
            "not-in-future",
            "Award date cannot be in the future.",
            (value) => {
                if (!value) {
                    return true;
                }

                return new Date(value) <= new Date();
            }
        )
        .required("Award date is required.")*/
});

export default compensationSchema;
